<div class="registerb3 contentPadding">
  <div class="modalb3">
    <div class="headerb3">
      <p class="spacer"></p>
      <p>{{ 'Register_Account' | t }}</p>
      <p class="spacer icon" [routerLink]="['/home']">✕</p>
    </div>

    <div *ngIf="registerStepB3 === 1" class="contentb3 step1">
      <form class="full-page-form centerItems" [formGroup]="registerDatasb3Step1" *ngIf="registerDatas" style="padding: 0px 10px 0px 0px">
        <ng-container *ngFor="let item of registerDatasB3Step1Structure; let k = index">
          <div [ngClass]="['form-groupb3', 'group_1']">
            <ng-container *ngIf="item.FType === 'input_mail'">
              <inputb3
                formControlName="{{ item?.fname }}"
                [fID]="item?.fname"
                [fHint]="item?.hint"
                [fErrorText]="item?.errText"
                [fPlaceholder]="item?.placeholder"
                fInputType="email"></inputb3>
            </ng-container>
            <ng-container *ngIf="mailIsUse">
              <p class="errorTextFP" style="text-decoration: underline" (click)="goLogin()">
                {{ 'alreadyregisteredemail' | t }}
              </p>
            </ng-container>
            <div class="submit-wrap btn-yellow" (click)="checkMailAddressUsage()">
              <button
                [disabled]="!registerDatasb3Step1.controls.mail.dirty || !registerDatasb3Step1.controls.mail.valid"
                type="submit"
                id="submitBtnCheck"
                class="buttonSuccess btn-yellow">
                {{ 'Continue' | t }}
              </button>
            </div>
            <div class="submit-wrap btn-yellow" *ngIf="mailIsUse" (click)="this._UiHelper.toogleForgotPass()">
              <button id="goTofPfromlogin" class="buttonSuccess btn-yellow">
                {{ 'Forgot_Password' | t }}
              </button>
            </div>
            <div class="submit-wrap btn-yellow" *ngIf="mailIsUse">
              <button id="goTofPfromlogin" class="buttonSuccess btn-yellow">
                <a href="mailto:support@bet3000.de" style="color: #212529">
                  {{ 'contactsupport2' | t }}
                </a>
              </button>
            </div>
          </div>
        </ng-container>
      </form>
    </div>

    <div *ngIf="registerStepB3 === 2" class="contentb3">
      <form class="full-page-form" [formGroup]="registerDatas" *ngIf="registerDatas" style="padding: 0px 10px 0px 0px">
        <ng-container *ngFor="let groupOfForm of registerDatasStructure; let k = index">
          <div [ngClass]="['form-groupb3', 'group_' + groupOfForm.group]">
            <ng-container *ngFor="let item of groupOfForm.data; let i = index">
              <ng-container *ngIf="item.FType === 'group_name'">
                <div class="group_name">
                  <p>{{ item?.text }}</p>
                </div>
              </ng-container>

              <ng-container *ngIf="item.FType === 'input_text'">
                <inputb3 formControlName="{{ item?.fname }}" [fID]="item?.fname" [fHint]="item?.hint" [fErrorText]="item?.errText" [fPlaceholder]="item?.placeholder"></inputb3>
              </ng-container>

              <ng-container *ngIf="item.FType === 'input_mail'">
                <inputb3
                  formControlName="{{ item?.fname }}"
                  [fID]="item?.fname"
                  [fHint]="item?.hint"
                  [fErrorText]="item?.errText"
                  [fPlaceholder]="item?.placeholder"
                  fInputType="email"
                  [disabled]="true"></inputb3>
              </ng-container>

              <ng-container *ngIf="item.FType === 'input_checkbox'">
                <inputb3 formControlName="{{ item?.fname }}" [fID]="item?.fname" [fHint]="item?.hint" [fPlaceholder]="item?.placeholder" fInputType="checkbox"></inputb3>
              </ng-container>

              <ng-container *ngIf="item.FType === 'input_number'">
                <inputb3
                  formControlName="{{ item?.fname }}"
                  [fID]="item?.fname"
                  [fHint]="item?.hint"
                  [fErrorText]="item?.errText"
                  [fPlaceholder]="item?.placeholder"
                  fInputType="number"></inputb3>
              </ng-container>

              <ng-container *ngIf="item.FType === 'input_password'">
                <inputb3
                  formControlName="{{ item?.fname }}"
                  [fID]="item?.fname"
                  [fHint]="item?.hint"
                  [fErrorText]="item?.errText"
                  [fPlaceholder]="item?.placeholder"
                  [fAutoComplete]="item?.autoComplete"
                  fInputType="password"></inputb3>
              </ng-container>

              <ng-container *ngIf="item.FType === 'dropdown'">
                <dropdownb3
                  formControlName="{{ item?.fname }}"
                  [fID]="item?.fname"
                  [fHint]="item?.hint"
                  [fPlaceholder]="item?.placeholder"
                  [fErrorText]="item?.errText"
                  fDefaultSelectText="{{ 'b3000_pick_one' | t }}"></dropdownb3>
              </ng-container>

              <ng-container *ngIf="item.FType === 'input_country'">
                <dropdownb3
                  formControlName="{{ item?.fname }}"
                  [fID]="item?.fname"
                  [fHint]="item?.hint"
                  [fPlaceholder]="item?.placeholder"
                  [fErrorText]="item?.errText"
                  [fData]="this.countryListLangAPI"
                  [fDataValueKey]="'CountryId'"
                  [fDataViewKey]="'Country'"
                  fDefaultSelectText="{{ 'b3000_pick_one' | t }}"></dropdownb3>
              </ng-container>
              <ng-container *ngIf="item.FType === 'input_country_extention'">
                <dropdownb3
                  formControlName="{{ item?.fname }}"
                  [fID]="item?.fname"
                  [fHint]="item?.hint"
                  [fPlaceholder]="item?.placeholder"
                  [fErrorText]="item?.errText"
                  [fData]="this.countryListExtentionData"
                  [fDataValueKey]="'CountryId'"
                  [fDataViewKey]="'Country'"
                  fDefaultSelectText="{{ 'b3000_pick_one' | t }}"></dropdownb3>
              </ng-container>
              <ng-container *ngIf="item.FType === 'input_currency'">
                <dropdownb3
                  formControlName="{{ item?.fname }}"
                  [fID]="item?.fname"
                  [fHint]="item?.hint"
                  [fPlaceholder]="item?.placeholder"
                  [fErrorText]="item?.errText"
                  [fData]="this.currencyList"
                  [fDataValueKey]="'CurrencyId'"
                  [fDataViewKey]="'Currency'"
                  fDefaultSelectText="{{ 'b3000_pick_one' | t }}"></dropdownb3>
              </ng-container>
              <ng-container *ngIf="item.FType === 'input_languageP'">
                <dropdownb3
                  formControlName="{{ item?.fname }}"
                  [fID]="item?.fname"
                  [fHint]="item?.hint"
                  [fPlaceholder]="item?.placeholder"
                  [fErrorText]="item?.errText"
                  [fData]="this.langDatasArry"
                  [fDataValueKey]="'langID'"
                  [fDataViewKey]="'langNativeNames'"
                  fDefaultSelectText="{{ 'b3000_pick_one' | t }}"></dropdownb3>
              </ng-container>
              <ng-container *ngIf="item.FType === 'input_date'">
                <datepickerb3
                  formControlName="{{ item?.fname }}"
                  [fID]="item?.fname"
                  [fHint]="item?.hint"
                  [fPlaceholder]="item?.placeholder"
                  [fErrorText]="item?.errText"
                  [isAgeControl]="true"></datepickerb3>
              </ng-container>

              <ng-container *ngIf="item.FType === 'input_title_firstname'">
                <div class="two-fields">
                  <dropdownb3
                    formControlName="{{ 'titleId' }}"
                    [fID]="'title'"
                    [fHint]="item?.hint"
                    fPlaceholder="{{ 'Title' | t }}"
                    [fErrorText]="item?.errText"
                    [fData]="this.saluteList"
                    [fDataValueKey]="'SalutationId'"
                    [fDataViewKey]="'Salutation'"
                    fDefaultSelectText=""></dropdownb3>
                  <inputb3 formControlName="{{ item?.fname }}" [fID]="item?.fname" [fHint]="item?.hint" [fErrorText]="item?.errText" [fPlaceholder]="item?.placeholder"></inputb3>
                </div>
              </ng-container>
              <ng-container *ngIf="item.FType === 'input_full_address'">
                <inputb3 formControlName="{{ item?.fname }}" [fID]="item?.fname" [fHint]="item?.hint" [fErrorText]="item?.errText" [fPlaceholder]="item?.placeholder"></inputb3>
              </ng-container>

              <ng-container *ngIf="item.FType === 'input_address'">
                <div class="two-fields reverse">
                  <inputb3
                    [disabled]="true"
                    formControlName="{{ item?.fname }}"
                    [fID]="item?.fname"
                    [fHint]="item?.hint"
                    [fErrorText]="item?.errText"
                    [fPlaceholder]="item?.placeholder"></inputb3>
                  <inputb3 formControlName="housenumber" [fID]="'housenumber'" [fErrorText]="item?.errText2" fPlaceholder="{{ 'b3000_Street_number' | t }}"></inputb3>
                </div>
              </ng-container>

              <ng-container *ngIf="item.FType === 'input_zip_city'">
                <div class="two-fields">
                  <inputb3
                    [disabled]="true"
                    formControlName="{{ item?.fname }}"
                    [fID]="item?.fname"
                    [fHint]="item?.hint"
                    [fErrorText]="item?.errText"
                    [fPlaceholder]="item?.placeholder"></inputb3>
                  <inputb3 [disabled]="true" formControlName="city" [fID]="'city'" [fErrorText]="item?.errText2" fPlaceholder="{{ 'City' | t }}"></inputb3>
                </div>
              </ng-container>

              <ng-container *ngIf="item.FType === 'input_phoneC_phone'">
                <div class="two-fields">
                  <dropdownb3
                    formControlName="{{ item?.fname }}"
                    [fID]="item?.fname"
                    [fHint]="item?.hint"
                    [fErrorText]="item?.errText"
                    [fPlaceholder]="item?.placeholder"
                    [fData]="this.PhoneNumberList"
                    [fDataValueKey]="'PhoneCodeId'"
                    [fDataViewKey]="'PhoneCode'"></dropdownb3>
                  <inputb3 formControlName="{{ 'phone' }}" [fErrorText]="item?.errText2" [fPlaceholder]="item.placeholder2"></inputb3>
                </div>
              </ng-container>
              <ng-container *ngIf="item.FType === 'checkboxClick'">
                <ng-container>
                  <div class="form-b3 form-field-b3 checkbox">
                    <label for="isBonus" class="label-b3">
                      <div class="text-1">
                        {{ 'b3000_Register_checkbox_text_01' | t }}
                      </div>
                      <a
                        class="text-1"
                        style="text-decoration: underline; font-weight: bold; color: #000"
                        target="_blank"
                        [routerLink]="['/article/bonus' + '-' + this._LocalizationService?.LANGCODE]">
                        {{ 'b3000_Register_checkbox_text_03' | t }}
                      </a>
                      <a class="text-1">{{ 'b3000_Register_checkbox_text_02' | t }}</a>
                    </label>
                    <div class="input-container checkbox">
                      <input class="formType_checkbox" type="checkbox" id="isBonus" name="isBonus" formControlName="isBonus" />
                    </div>
                  </div>
                </ng-container>
                <ng-container>
                  <div class="form-b3 form-field-b3 checkbox">
                    <label for="agreement" class="label-b3">
                      <div class="text-1">
                        {{ 'b3000_Register_checkbox_text_5' | t }}
                      </div>
                      <a class="text-1" style="text-decoration: underline; font-weight: bold; color: #000" routerLink="/article/{{ 'route_article_footer_5' | t }}" target="_blank"
                        >AGB
                      </a>
                      <a class="text-1">
                        {{ 'b3000_Register_checkbox_text_8' | t }}
                      </a>

                      <a class="text-1" style="text-decoration: underline; font-weight: bold; color: #000" routerLink="/article/{{ 'route_article_footer_4' | t }}" target="_blank"
                        >{{ 'footer_privacy_cookies' | t }}.</a
                      >
                      <!-- <div class="text-1">
                        {{ "b3000_Register_checkbox_text_7" | t }}
                      </div> -->
                    </label>
                    <div class="input-container checkbox">
                      <input class="formType_checkbox" type="checkbox" id="agreement" name="agreement" required="isRequired" formControlName="agreement" />
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="item.FType === 'submit'">
                <div class="submit-wrap">
                  <button [disabled]="!this.registerDatas.valid" type="submit" id="submitBtn" class="buttonSuccess" (click)="signUp()">
                    {{ 'Confirm' | t }}
                  </button>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
      </form>
    </div>
  </div>
</div>
